// extracted by mini-css-extract-plugin
module.exports = {"container":"document_container__a3DIF","title":"document_title__uZoqe","img":"document_img__NCLkX"};